/* eslint-disable max-len */
import { MemoryTranslations } from '../interfaces/mamory';

const EnglishMemoryTranslations: MemoryTranslations = {
  congratulations: 'Well done!',
  finished: {
    new: 'New round',
    close: 'Finish',
  },
};

export default EnglishMemoryTranslations;
